import React from 'react';
import { AddIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import { addAppliance } from '../circuitApplianceConfigSlice';

export function AddApplianceButton() {
  const dispatch = useDispatch();

  const handleAddAppliance = () => {
    dispatch(addAppliance({ name: 'New Appliance', type: 'not_set' }));
  };

  return (
    <Button
      leftIcon={<AddIcon w={3} h={3} _dark={{ color: 'white' }} />}
      variant="ghost"
      fontWeight="normal"
      color="gray.700"
      _dark={{ color: 'gray.400' }}
      onClick={handleAddAppliance}
      data-testid="add-appliance-button"
    >
      Add Appliance
    </Button>
  );
}
